export interface CountdownParts {
  days: string
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number): string => String(value).padStart(2, '0')

export function countdownParts(targetMs: number, nowMs: number): CountdownParts {
  const total = Math.max(0, Math.floor((targetMs - nowMs) / 1000))
  return {
    days: pad(Math.floor(total / 86_400)),
    hours: pad(Math.floor((total % 86_400) / 3_600)),
    minutes: pad(Math.floor((total % 3_600) / 60)),
    seconds: pad(total % 60),
  }
}
